const CountdownCircle = ({
  seconds,
  total,
  C,
}: {
  seconds: number;
  total: number;
  C: any;
}) => {
  const size = 120;
  const r = 50;
  const circumference = 2 * Math.PI * r;
  const progress = seconds / total;
  const offset = circumference * (1 - progress);
  const clr = seconds <= 5 ? C.red : C.cyan;
  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 120 120"
        className="transform -rotate-90"
      >
        <circle
          cx="60"
          cy="60"
          r={r}
          fill="none"
          stroke="rgba(255,255,255,0.06)"
          strokeWidth="5"
        />
        <circle
          cx="60"
          cy="60"
          r={r}
          fill="none"
          stroke={clr}
          strokeWidth="5"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.5s linear, stroke 0.3s" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="mono-num text-3xl font-bold" style={{ color: clr }}>
          {seconds}
        </span>
        <span className="text-[10px]" style={{ color: C.dim }}>
          s
        </span>
      </div>
    </div>
  );
};
export default CountdownCircle;
